import { BaseCRUDService } from './baseService';
import { axios } from './api';

const baseUrl = process.env.REACT_APP_API_URL;

class LabelCRUDService extends BaseCRUDService {
  get_lock(id) {
    return axios.get(`${this.base}/${id}/get_lock/`, {}).then((res) => res);
  }

  get_next(id, params) {
    return axios.get(`${this.base}/${id}/next/`, { params: params }).then((res) => res.data);
  }

  addLabel(id, data) {
    return axios.post(`${this.base}/${id}/add_label/`, data).then((res) => res.data);
  }
}

class PubMedDataItemsCRUDService extends BaseCRUDService {
  search(params) {
    return axios.get(`${this.base}/search/`, { params: params }).then((res) => res.data);
  }

  stats(params) {
    return axios.get(`${this.base}/agg_info/`, { params: params }).then((res) => res.data);
  }

  scoringData(params) {
    return axios.get(`${this.base}/scoring/`, { params: params }).then((res) => res.data);
  }

  vectorSearch(params) {
    return axios.get(`${this.base}/vector_search/`, { params: params }).then((res) => res.data);
  }

  pubmedSearch(params) {
    return axios.get(`${this.base}/pubmed_search/`, { params: params }).then((res) => res.data);
  }

  drugScoring(params) {
    return axios.get(`${this.base}/scoring/`, { params: params }).then((res) => res.data);
  }
  importArticles(data) {
    return axios.post(`${this.base}/import_articles/`, data).then((res) => res.data);
  }

  importOtherArticles(data) {
    return axios.post(`${this.base}/import_other_articles/`, data).then((res) => res.data);
  }

  summarize(data) {
    return axios.post(`${this.base}/summarize/`, data).then((res) => res.data);
  }

  filter_suggest(params) {
    return axios.get(`${this.base}/filter_suggest/`, { params: params }).then((res) => res.data);
  }

  filter_suggest_all(params) {
    return axios.get(`${this.base}/filter_suggest_all/`, { params: params }).then((res) => res.data);
  }

  addFeedback(id, data) {
    return axios.post(`${this.base}/${id}/add_feedback/`, data).then((res) => res.data);
  }

  uploadPdf(id, data) {
    return axios.post(`${this.base}/${id}/upload_pdf/`, data).then((res) => res.data);
  }

  downloadPdf(id) {
    return axios.get(`${this.base}/${id}/download_pdf/`, { responseType: 'blob' }).then((res) => res.data);
  }

  getAnnotations(id) {
    return axios.get(`${this.base}/${id}/get_annotations/`).then((res) => res.data);
  }
  saveComment(id, data) {
    return axios.post(`${this.base}/${id}/comments/`, data).then((res) => res.data);
  }

  getComments(id, params) {
    return axios.get(`${this.base}/${id}/comments/`, { params: params }).then((res) => res.data);
  }

  deleteComment(id) {
    return axios.delete(`${this.base}/comments/${id}/`).then((res) => res.data);
  }

  getValidations(id) {
    return axios.get(`${this.base}/${id}/get_validated_data/`).then((res) => res.data);
  }

  otherDetails(id) {
    return axios.get(`${this.base}/${id}/other_details/`).then((res) => res.data);
  }

  exportToExcel(params) {
    // Download the file response from the server
    return axios
      .get(`${this.base}/search_export/`, {
        params: params,
        responseType: 'blob',
      })
      .then((res) => {
        // Create a blob object from the file response
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // Create a link element to download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'pubmed_search.xlsx';
        // Append the link element to the DOM
        document.body.appendChild(link);
        // Dispatch a click event on the link element
        link.click();
        // Remove the link element from the DOM
        document.body.removeChild(link);
      })
      .catch((error) => {
        // Handle backend export size limit (EXPORT_TOO_LARGE)
        const detail = error?.response?.data?.detail;
        let message = 'Failed to export results.';

        if (detail && typeof detail === 'object' && detail.code === 'EXPORT_TOO_LARGE') {
          const total = detail.total_results ?? 'many';
          const max = detail.max_results ?? 10000;
          message =
            detail.message ||
            `Too many results to export (${total}). Please apply more filters to reduce below ${max} and try again.`;
        } else if (typeof detail === 'string') {
          message = detail;
        }

        // eslint-disable-next-line no-alert
        window.alert(message);
        throw error;
      });
  }
}

class PubMedConfigCRUDService extends BaseCRUDService {
  getConfig(params) {
    return axios.get(`${this.base}/data-config/`, { params: params }).then((res) => res.data);
  }

  updateConfig(data) {
    return axios.post(`${this.base}/data-config/`, data).then((res) => res.data);
  }
}

class ValidationCRUDService extends BaseCRUDService {
  saveAnnotation(id, data) {
    return axios.post(`${this.base}/${id}/save/`, data).then((res) => res.data);
  }
  deleteAnnotation(id, data) {
    return axios.delete(`${this.base}/${id}/delete/`, { data: data }).then((res) => res.data);
  }

  getNext(id, params) {
    return axios
      .get(`${this.base}/${id}/next/`, {
        params: params,
      })
      .then((res) => res.data);
  }

  getSets(params) {
    return axios.get(`${this.base}/sets/`, { params: params }).then((res) => res.data);
  }

  getSetsV2(params) {
    return axios.get(`${this.base}/sets/v2/`, { params: params }).then((res) => res.data);
  }

  getTasksV2(params) {
    return axios.get(`${this.base}/v2/`, { params: params }).then((res) => res.data);
  }

  exportData() {
    return axios
      .post(
        `${this.base}/export/`,
        {},
        {
          responseType: 'blob',
        },
      )
      .then((res) => {
        // Download the file response from the server excel file xlsx
        // Create a blob object from the file response
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // Create a link element to download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'pubmed_data.xlsx';
        // Append the link element to the DOM
        document.body.appendChild(link);
        // Dispatch a click event on the link element
        link.click();
        // Remove the link element from the DOM

        document.body.removeChild(link);
      });
  }
}

class ValidationV2CRUDService extends BaseCRUDService {
  saveAnnotation(id, data) {
    return axios.post(`${this.base}/${id}/save/`, data).then((res) => res.data);
  }
  saveGenericAnnotation(id, data) {
    return axios.post(`${this.base}/${id}/generic_save/`, data).then((res) => res.data);
  }
  saveDrugAnnotation(id, data) {
    return axios.post(`${this.base}/${id}/drug_save/`, data).then((res) => res.data);
  }
  deleteAnnotation(id, data) {
    return axios.delete(`${this.base}/${id}/delete/`, { data: data }).then((res) => res.data);
  }

  getNext(id, params) {
    return axios
      .get(`${this.base}/${id}/next/`, {
        params: params,
      })
      .then((res) => res.data);
  }

  getValidators(params) {
    return axios.get(`${this.base}/validators/`, { params: params }).then((res) => res.data);
  }

  getSets(params) {
    return axios.get(`${this.base}/sets/`, { params: params }).then((res) => res.data);
  }

  getTasks(params) {
    return axios.get(`${this.base}/`, { params: params }).then((res) => res.data);
  }

  exportData() {
    return axios
      .post(
        `${this.base}/export/`,
        {},
        {
          responseType: 'blob',
        },
      )
      .then((res) => {
        // Download the file response from the server excel file xlsx
        // Create a blob object from the file response
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // Create a link element to download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'pubmed_data.xlsx';
        // Append the link element to the DOM
        document.body.appendChild(link);
        // Dispatch a click event on the link element
        link.click();
        // Remove the link element from the DOM

        document.body.removeChild(link);
      });
  }

  getConsensusArticles() {
    return axios.get(`${this.base}/consensus_articles/`).then((res) => res.data);
  }

  getConsensusArticleDetails(id) {
    return axios.get(`${this.base}/consensus_articles/${id}/`).then((res) => res.data);
  }

  saveConsensusArticle(id, data) {
    return axios.post(`${this.base}/consensus_articles/${id}/save/`, data).then((res) => res.data);
  }
}

class DocsCRUDService extends BaseCRUDService {
  search(params) {
    return axios.get(`${this.base}/search/`, { params: params }).then((res) => res.data);
  }

  getComments(id) {
    return axios.get(`${this.base}/${id}/comments/`).then((res) => res.data);
  }

  addComment(id, data) {
    return axios.post(`${this.base}/${id}/comments/`, data).then((res) => res.data);
  }

  getFilters(params) {
    return axios.get(`${this.base}/filter_suggest_all/`, { params: params }).then((res) => res.data);
  }

  exportToExcel(params) {
    return axios
      .get(`${this.base}/search_export/`, {
        params: params,
        responseType: 'blob',
      })
      .then((res) => res.data);
  }

  importArticles(data) {
    return axios.post(`${this.base}/import_articles/`, data).then((res) => res.data);
  }

  importOtherArticles(data) {
    return axios.post(`${this.base}/import_other_articles/`, data).then((res) => res.data);
  }

  checkImportStatus(data) {
    return axios.get(`${this.base}/import_status/`, { params: data }).then((res) => res.data);
  }

  getAggregatedData(params) {
    return axios.get(`${this.base}/agg_info/`, { params: params }).then((res) => res.data);
  }

  getDrugScoringOptions() {
    return axios.get(`${this.base}/drug_scoring_agg_options/`).then((res) => res.data);
  }

  getDrugScoringAggregation(params) {
    // Requires at least one of 'drug' or 'cancer_type' parameter
    return axios.get(`${this.base}/drug_scoring_agg/`, { params: params }).then((res) => res.data);
  }

  exportDrugScoringAggregation(params) {
    // Start export job - returns job_id
    // Background export has no limits - can handle any dataset size
    // Now accepts selected_pairs (JSON string) or export_all (boolean string)
    return axios
      .post(`${this.base}/drug_scoring_agg_export/`, null, {
        params: params,
      })
      .then((res) => {
        return res.data; // Returns { job_id, status, message }
      })
      .catch((error) => {
        // Handle errors without mentioning limits (background exports have no limits)
        const detail = error?.response?.data?.detail;
        let message = 'Failed to start export job.';

        if (typeof detail === 'string') {
          message = detail;
        } else if (detail && typeof detail === 'object' && detail.message) {
          message = detail.message;
        }

        // Create a new error with the message
        const exportError = new Error(message);
        exportError.response = error.response;
        throw exportError;
      });
  }

  getExportStatus(jobId) {
    return axios.get(`${this.base}/drug_scoring_agg_export_status/${jobId}/`).then((res) => {
      return res.data;
    });
  }

  downloadExport(jobId) {
    return axios
      .get(`${this.base}/drug_scoring_agg_export_download/${jobId}/`, {
        responseType: 'blob',
        timeout: 300000, // 5 minute timeout for large files
      })
      .then((res) => {
        // Validate response data exists
        if (!res.data || res.data.size === 0) {
          throw new Error('Downloaded file is empty or invalid');
        }

        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;

        // Extract filename from Content-Disposition header or use default
        const contentDisposition = res.headers['content-disposition'];
        let filename = `drug_scoring_aggregation_${Date.now()}.xlsx`;
        if (contentDisposition) {
          // Handle both quoted and unquoted filenames, and decode if needed
          // Match: filename="value" or filename=value or filename*=UTF-8''value
          const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^'";\n]+)['"]?/i);
          if (filenameMatch) {
            filename = filenameMatch[1];
            // Decode URL encoding if present (e.g., %20 for space)
            try {
              filename = decodeURIComponent(filename);
            } catch (e) {
              // If decoding fails, use as-is
            }
            // Clean filename: remove trailing underscores and ensure .xlsx extension
            filename = filename.trim();
            // Remove any trailing underscores before the extension
            filename = filename.replace(/[_\s]+\.xlsx$/i, '.xlsx');
            // Ensure it ends with .xlsx (case insensitive)
            if (!filename.toLowerCase().endsWith('.xlsx')) {
              filename = filename.replace(/[_\s]*$/, '') + '.xlsx';
            }
          }
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return res.data;
      })
      .catch((error) => {
        // Provide more helpful error messages
        if (error.code === 'ECONNABORTED') {
          throw new Error('Download timeout - file may be too large. Please try again.');
        } else if (error.message === 'Network Error' || !error.response) {
          throw new Error('Network error during download. Please check your connection and try again.');
        } else if (error.response?.status === 404) {
          throw new Error('Export file not found. The export may have expired or been deleted.');
        } else if (error.response?.status === 403) {
          throw new Error('Access denied. You may not have permission to download this export.');
        } else {
          throw error;
        }
      });
  }

  getExportHistory(page = 1, pageSize = 20) {
    return axios
      .get(`${this.base}/drug_scoring_agg_export_history/`, {
        params: { page, page_size: pageSize },
      })
      .then((res) => {
        return res.data;
      });
  }

  updateSuggestions(id, data) {
    return axios.put(`${this.base}/${id}/update_suggestions/`, data).then((res) => res.data);
  }

  listSuggestionArticles() {
    return axios.get(`${this.base}/suggestions/`).then((res) => res.data);
  }
}
export const LabelTask = new BaseCRUDService('label/tasks');

export const PubmedData = new BaseCRUDService('pubmed/data');

export const PubmedConfig = new PubMedConfigCRUDService('pubmed');

export const ValidationTask = new ValidationCRUDService('validation');

export const ValidationTaskV2 = new ValidationV2CRUDService('validation_v2');

export const ValidationTaskV3 = new ValidationV2CRUDService('validation_v3');

export const PubmedDataItems = new PubMedDataItemsCRUDService('pubmed/data/items');

export const LabelItem = new LabelCRUDService('label/tasks/items');

export const SupplierService = new BaseCRUDService('supplier');

export const DocService = new DocsCRUDService('docs');
class HelperServices_ {
  getAllUsers() {
    return axios.get(`${baseUrl}/auth/users/all/`).then((res) => res.data);
  }

  drive_files(params) {
    return axios.get(`${baseUrl}/drive_files`, { params: params }).then((res) => res.data);
  }
}

class LLMService_ {
  getGPTPredictions(data) {
    return axios.post(`${baseUrl}/llm/gpt/`, data).then((res) => res.data);
  }

  getClaudePredictions(data) {
    return axios.post(`${baseUrl}/llm/claude/`, data).then((res) => res.data);
  }

  createGPTSummary(data) {
    return axios.post(`${baseUrl}/llm/research_topic/`, data).then((res) => res.data);
  }

  getAllSummary(params) {
    return axios.get(`${baseUrl}/llm/research_topic/`, { params: params }).then((res) => res.data);
  }

  kgChat(data) {
    return axios.post(`${baseUrl}/llm/kg-chat/`, data).then((res) => res.data);
  }

  pubmedResearch(data) {
    return axios.post(`${baseUrl}/llm/pubmed-research/`, data).then((res) => res.data);
  }

  pubmedGraph(data) {
    return axios.post(`${baseUrl}/llm/pubmed-graph/`, data).then((res) => res.data);
  }
}

class ReferenceService_ {
  getDocs(params) {
    return axios.get(`${baseUrl}/references/docs`, { params: params }).then((res) => res.data);
  }

  getReferenceCheck(data) {
    return axios.get(`${baseUrl}/references/reference_check`, { params: data }).then((res) => res.data);
  }

  addDoc(data) {
    return axios.post(`${baseUrl}/references/docs/`, data).then((res) => res.data);
  }

  deleteDoc(id) {
    return axios.delete(`${baseUrl}/references/docs/${id}`).then((res) => res.data);
  }

  getPdf(id) {
    return axios.get(`${baseUrl}/references/docs/${id}/get_pdf`, { responseType: 'blob' }).then((res) => res.data);
  }
}

class BookmarkPage extends BaseCRUDService {
  addItem(data) {
    return axios.post(`${this.base}/add_item/`, data).then((res) => res.data);
  }

  addItems(data) {
    return axios.post(`${this.base}/add_multiple_items/`, data).then((res) => res.data);
  }

  checkItem(item_id) {
    return axios
      .get(`${this.base}/check_item/`, {
        params: { item_id: item_id },
      })
      .then((res) => res.data);
  }

  deleteItem(id) {
    return axios.delete(`${this.base}/item/${id}/`).then((res) => res.data);
  }

  getItems(id, params) {
    return axios.get(`${this.base}/${id}/items/search/`, { params: params }).then((res) => res.data);
  }

  exportItems(id) {
    return axios
      .get(`${this.base}/${id}/export/`, {
        responseType: 'blob',
      })
      .then((res) => {
        // Download the file response from the server excel file xlsx
        // Create a blob object from the file response
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        // Create a link element to download the file
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'bookmarks.xlsx';
        // Append the link element to the DOM
        document.body.appendChild(link);
        // Dispatch a click event on the link element
        link.click();
        // Remove the link element from the DOM

        document.body.removeChild(link);
      });
  }
}

export const LLMService = new LLMService_();
export const HelperServices = new HelperServices_();
export const BookmarkService = new BookmarkPage('bookmark');
export const ReferenceService = new ReferenceService_();
export const PipelineRunService = new BaseCRUDService('pipeline_run');
